<script>
export default {
  props: {
    pathPrefix: {
      type: String,
      default: "https://res.cloudinary.com/vectorworks-mktg/video/upload/",
    },
    pathSufix: {
      type: String,
      default: `Rodrigo_tests_/launch_2023/`,
    },
    video: {
      type: Object,
      default: () => ({}),
    },
    videoName: {
      type: String,
      default: "i5pcccmvp5uwgwkg8kpn",
    },
    posterUrl: {
      type: String,
      default:
        "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1621624353/Rodrigo_tests_/banners_test/arch_banner_test_lqiwpf.jpg",
    },
    videoRef: {
      type: String,
      default: "video1",
    },
  },
  computed: {
    videoURL() {
      const srcStr = this.video.videoUrl;
      return srcStr.split(/v\d{5,12}/);
    },
  },
};
</script>
<template>
  <video
    muted
    loop
    playsinline
    :ref="video.id"
    :poster="`${videoURL[0]}so_0${videoURL[1]}.jpg`"
    :data-id="video.id"
  >
    <source
      :data-src="`${videoURL[0]}q_90/vc_h265/w_1920/c_limit/${videoURL[1]}.mp4`"
      type="video/mp4; codecs=hvc1"
    />
    <source
      :data-src="`${videoURL[0]}q_90/vc_vp9/w_1920/c_limit/${videoURL[1]}.webm`"
      type="video/webm; codecs=vp9"
    />
    <source
      :data-src="`${videoURL[0]}q_90/w_1920/c_limit/${videoURL[1]}.mp4`"
      type="video/mp4"
    />
  </video>
</template>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppVideoPlayer.vue